// @flow
import React from 'react';
import { Skeleton } from '@duxton-web/ui';
import './ProgressiveContainer.scss';

type Props = {
  isLoading: boolean,
  message: string,
  style: Object,
  children: React$Element<*>,
};

const ProgressiveContainer = ({ isLoading = false, style, children }: Props) => {
  // const loadingMessage = useMemo(() => message || i18n.t('loader.loading'), [message]);

  return (
    <div className="progressive-container" style={style}>
      {isLoading ? <Skeleton active /> : <div>{children}</div>}
    </div>
  );
};

export default ProgressiveContainer;
